"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const Modal_1 = __importDefault(require("@mui/material/Modal"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const openModal = (0, react_redux_1.useSelector)((state) => state.openPromiseEditModal);
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(Modal_1.default, Object.assign({ open: openModal, slotProps: { backdrop: { sx: { bgcolor: maxWidth768 ? 'transparent' : 'var(--gray-80)' } } }, sx: {
            display: 'block',
            overflow: 'scroll',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: maxWidth768 ? '800px' : '480px',
            height: maxWidth768 ? 'unset' : '800px',
            margin: 'auto',
            backgroundColor: 'var(--white)',
        } }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(NoticeContainer, { children: [(0, jsx_runtime_1.jsx)("h3", { children: `•  ${t('작품금액 수정/추가/복제 → [약속폼]으로 변경')}` }), (0, jsx_runtime_1.jsxs)("h4", Object.assign({ css: { display: 'inline-flex' } }, { children: [(0, jsx_runtime_1.jsx)("span", { children: "\u2022" }), `  ${t('무료폼 유지 → 수정완료 버튼을 누르지 말아주세요')}`] }))] }), (0, jsx_runtime_1.jsx)("img", { src: '/static/user/res/promise.gif', css: { width: '100%' } }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "surface-white", css: {
                        display: 'flex',
                        position: maxWidth768 ? 'sticky' : 'absolute',
                        width: '100%',
                        bottom: 0,
                        padding: 20,
                        borderRadius: '0 0 4px 4px',
                    } }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ sx: {
                            height: '50px',
                            p: '6px',
                            bgcolor: 'var(--secondary-main) !important',
                            color: 'white',
                            fontSize: '16px',
                            fontWeight: 700,
                        }, fullWidth: true, onClick: () => dispatch((0, roomCreateStore_1.setOpenPromiseEditModal)(false)) }, { children: "\uD655\uC778\uD588\uC5B4\uC694!" })) }))] }) })));
}
exports.default = default_1;
const NoticeContainer = styled_1.default.div `
  height: 80px;
  padding: 14px 10px;
  border-radius: 4px 4px 0px 0px;
  background: #fdf3ec;
  h3,
  span {
    font-weight: 800;
    font-size: 16px;
    line-height: 26px;
    letter-spacing: -0.2px;
    color: #000000;
  }
  h4 {
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    letter-spacing: -0.2px;
    color: #000000;
  }
`;
